import axios from "axios";

// const API = axios.create({
//     baseURL: "http://localhost:5000",
// });

const API = axios.create({
    baseURL: "https://zpsajur-backend.onrender.com",
});

export const getQuiz = async (standard, subject) => {

    const response = await API.get(
        `/api/quizzes/play/${standard}/${subject}`
    );

    return response.data;
};

export const startQuiz = async (quizData) => {

    const response = await API.post(
        "/api/quizzes/start",
        quizData
    );

    return response.data;
};

export const submitQuiz = async (submissionData) => {

    const response = await API.post(
        "/api/quizzes/submit",
        submissionData
    );

    return response.data;
};



export const getRankings = async (quizId) => {

    const token = localStorage.getItem("token");

    const response = await API.get(

        `/api/quizzes/rankings/${quizId}`,

        {

            headers: {

                Authorization: `Bearer ${token}`

            }

        }

    );

    return response.data;

};


export const cancelQuiz = async (submissionId) => {

    const response = await API.delete(

        `/api/quizzes/cancel/${submissionId}`

    );

    return response.data;

};